import { buttonClassName } from '@/component/Button';
import { useFeedbackUrl } from '@/hook/useFeedbackUrl';

/** Settings, Profile: the feedback form as a row, present only when the
 * deployment names a form. The link carries the build and the handle, so a
 * report is attributable without the tester typing either. */
export function FeedbackRow() {
  const href = useFeedbackUrl();
  if (!href) return null;
  return (
    <div className="flex items-start justify-between gap-6 py-[4px]">
      <div>
        <div className="text-[15px] font-semibold">Send feedback</div>
        <p className="mt-1 max-w-[44ch] text-sm leading-[1.5] text-mute">
          Tell us what broke or what you would like. Opens a short form in a new tab.
        </p>
      </div>
      <a href={href} target="_blank" rel="noreferrer" className={buttonClassName({ variant: 'outline', size: 'sm', quiet: true })}>
        Send feedback
      </a>
    </div>
  );
}
